// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root___mv4H","info":"Note_info__23UO5","note":"Note_note__3wwQB","actions":"Note_actions__1HTkc"};